"use client";

import { getBrowserCountry } from "@/common/utilities/locale/getBrowserCountry";
import { useEffect, useState } from "react";

/**
 * The visitor's most likely country as an ISO 3166-1 alpha-2 code: undefined on
 * the first render, then the detected value.
 *
 * Resolved in an effect rather than during render because the server has no
 * visitor locale to read, so reading it while rendering would produce markup
 * that disagrees with the client's and break hydration. Consumers therefore
 * need to cope with the value arriving a beat late.
 */
export const useBrowserCountry = (): string | undefined => {
    const [country, setCountry] = useState<string | undefined>(undefined);

    useEffect(() => {
        setCountry(getBrowserCountry());
    }, []);

    return country;
};
